export function initDataNumbers() {
    // Thousands separators, so a counter that lands on 12400 reads "12,400" —
    // matching what the server rendered before the animation replaced it.
    const format = (value: number, decimals: boolean) =>
        decimals
            ? value.toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 })
            : Math.floor(value).toLocaleString();

    const counters = document.querySelectorAll<HTMLElement>('[data-number]');
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const counter = entry.target as HTMLElement;
                const target = parseFloat(counter.dataset.number!);
                const hasDecimals = target % 1 !== 0;
                const duration = 2000; // 2 seconds
                const step = target / (duration / 16); // 60fps
                let current = 0;

                const timer = setInterval(() => {
                    current += step;
                    if (current >= target) {
                        current = target;
                        clearInterval(timer);
                    }
                    counter.textContent = format(current, hasDecimals);
                }, 16);

                observer.unobserve(counter);
            }
        });
    });

    counters.forEach(counter => observer.observe(counter));
}
